// extracted by mini-css-extract-plugin
export default {"Plans":"Plans_Plans__RTc0b","heading":"Plans_heading__upHPa","tickIcon":"Plans_tickIcon__FcWxl","payment_modal":"Plans_payment_modal__F30mC"};